<rr-filter-bar
  #filterBar
  [filterService]="requestFilterService"
  (clearFilterValues)="clearFilterValues()"
></rr-filter-bar>
